/*
 *
 * Package: `@dbh/home-page`.
 *
 */const importHomePage=()=>import('./component-7f59a3aa.js'/*  webpackChunkName: 'dbh.home-page.component' */);// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importHomePage as default };
